import api from "./api";

export const postReportServiceOne = async (body: any) => {
    const response = await api.post(`requestService/`, body);
    return response.data;
};

type RequestServiceFilters = {
    search?: string;
    status?: string;
    client?: string;
    dateInit?: string;
    dateEnd?: string;
}

export const getReportServicesAll = async (plant?: string, unitBranch?: string, filters?: RequestServiceFilters) => {
    const params = new URLSearchParams({
        plant: plant ? plant : "",
        unitBranch: unitBranch ? unitBranch : "",
        search: filters?.search ? filters.search : "",
        status: filters?.status ? filters.status : "",
        client: filters?.client ? filters.client : "",
        dateInit: filters?.dateInit ? filters.dateInit : "",
        dateEnd: filters?.dateEnd ? filters.dateEnd : "",
    });
    const response = await api.get(`requestService/listAll/?${params.toString()}`,);
    return response.data;
};

export const getReportServiceOne = async (id: string) => {
    const response = await api.get(`requestService/${id}`);
    return response.data;
};

export const putReportService = async (body: any, id: string) => {
    const response = await api.put(`requestService/${id}`, body);
    return response.data;
};


export const deleteRequestService = async (id: string) => {
    const response = await api.delete(`requestService/${id}`);
    return response.data;
};
